
var $ = seajs.require("$");

/**
 * 页面管理参数配置
 * @class nmcConfig
 * @static
 */
var config = {
  /**
   * 页面模块基础路径
   * @property basePath
   * @type String
   * @default 'modules/'
   */
  basePath: "modules/",

  /**
   * 页面包裹选择器
   * @property pageWrapper
   * @type String
   * @default '#pageWrapper'
   */
  pageWrapper: "#pageWrapper",

  /**
   * 页面主容器选择器
   * @property container
   * @type String
   * @default '#container'
   */
  container: "#container",

  /**
   * 右侧内容容器选择器
   * @property appArea
   * @type String
   * @default '#appArea'
   */
  appArea: "#appArea",
  /**
   * 左侧导航容器选择器
   * @property sidebar
   * @type String
   * @default '#sidebar'
   */
  sidebar: "#sidebar",

  /**
   * 切换页面需要更改class的容器选择器
   * @property classWrapper
   * @type String
   * @default '#container'
   */
  classWrapper: "#container",

  /**
   * 切换页面需要保留的class
   * @property defaultClass
   * @type String
   * @default ''
   */
  defaultClass: "",

  /**
   * 默认标题
   * @property defaultTitle
   * @type String
   * @default 'nmc'
   */
  defaultTitle: "控制台",

  /**
   * 导航容器选择器, 在各容器中遍历a标签, 执行选中态匹配
   * @property navContainer
   * @type Array
   * @default ['body']
   */
  navContainer: ["body"],

  /**
   * 导航选中class名
   * @property navActiveClass
   * @type String
   * @default 'active'
   */
  navActiveClass: "active",

  /**
   * 渲染前执行方法
   * @property beforeRender
   * @type Function
   * @default function (controller, action, params) {}
   */
  beforeRender: function (controller, action, params) { },

  /**
   * 渲染内容前执行方法
   * @property beforeContentRender
   * @type Function
   * @default function (obj) {}
   */
  beforeContentRender: function (obj) { },

  /**
   * 扩展路由，优先于框架路由逻辑
   * @property extendRoutes
   * @type Object
   * @default {}
   */
  extendRoutes: {},

  /**
   * 改变导航选中态
   * @property changeNavStatus
   * @type Function
   * @default 通用方法
   */
  changeNavStatus: null,

  /**
       * layout模版
       * @property layout
       * @type Object
       * @default {
          'default': {
            'controller': [],
            'module': 'nmc/layout/default'
          }
        }
       */
  layout: {
    default: {
      controller: [],
      module: "nmc/layout/default"
    }
  },

  /**
   * 侧边栏子菜单数据
   * @property subMenu
   * @type Object
   * @default {}
   */
  subMenu: {},

  /**
   * 首页模块名
   * @property root
   * @type String
   * @default 'home'
   */
  root: "home",

  /**
   * css配置
   * @property css
   * @type Object
   * @default {}
   */
  css: {},

  /**
       * 404提示
       * @property 404Html
       * @type String
       * @default '<h2 id="tt404" style="text-align:center;padding-top:100px;font-size:20px;line-height:1.5;color:#999">'+
       ' <p style="font-size:44px">404</p> 您访问的页面没有找到! </h2>'
       */
  html404:
    '<h2 id="tt404" style="text-align:center;padding-top:100px;font-size:20px;line-height:1.5;color:#999">' +
    ' <p style="font-size:44px">404</p> 您访问的页面没有找到! </h2>',

  /**
   * 加载中
   * @property htmlNoPerm
   * @type String
   */
  /*'htmlNoPerm': '<h2 id="tt404" style="text-align:center;padding-top:100px;font-size:20px;line-height:1.5;color:#999">'+
      ' <p style="font-size:44px">提示！</p> 您没有权限访问该页面! </h2>', */
  htmlNoPerm:
    '<div style="text-align: center;padding-top:25px;"><p class="tc-15-msg" style="padding:15px 0;font-size: 16px">您没有使用该功能的权限，请联系管理员开通</p></div>',

  /**
   * 加载中
   * @property htmlLoading
   * @type String
   */
  htmlLoading:
    '<h2 id="tt404" style="text-align:center;padding-top:100px;font-size:20px;line-height:1.5;color:#999">' +
    "   加载中...... </h2>",

  /**
   * 请求错误默认提示文字
   * @property defaultReqErr
   * @type String
   * @default '连接服务器异常，请稍后再试'
   */
  defaultReqErr: "连接服务器异常，请稍后再试",

  /**
   * 请求错误回调
   * @property reqErrorHandler
   * @type Function
   * @default null
   */
  reqErrorHandler: null,

  /**
   * 追加的url请求参数
   * @property additionalUrlParam
   * @type Function
   * @default null
   */
  additionalUrlParam: null,

  /**
   * 统一封装post的数据
   * @property packagePostData
   * @type Function
   * @default null
   */
  packagePostData: null,

  packageGetData: null,

  /**
   * 通用的接入层url地址
   * @property apiUrl
   * @type String
   * @default null
   */
  apiUrl: null,

  /**
   * 加载文字
   * @property loadingWord
   * @type String
   * @default '正在加载...'
   */
  loadingWord: "正在加载...",

  /**
   * 对话框默认按钮文字
   * @property dialogBtnTxt
   * @type Object
   * @default {'close': '关闭','submit': '确认','cancel': '取消','tips': '提示'}
   */
  dialogBtnTxt: {
    close: "关闭",
    submit: "确定",
    cancel: "取消",
    tips: "提示"
  },
  /** 不需要校验菜单权限的controller列表 gavingadd*/
  noCheckPermControllerList: [
    'main',
    'password',
    'account',
    'monitor-chart',
    'tgwchart',
    'license',
    'message'
  ]
};

export default config 
